import React from "react";
import {  FaArrowRight } from "react-icons/fa";
import imgMain from "../Images/image5.jpeg";

const Maintan = () => {
  const brandColor = "#224b8f";

  return (
    <section className="container-fluid py-5">
      <div className="container">
        <div className="row align-items-center align-content-center">

          {/* LEFT CONTENT */}
          <div className="col-lg-6 mb-5 mb-lg-0">

            {/* Small heading */}
            <div className="d-flex align-items-center mb-3">
              <span
                style={{
                 
                
              
                  display: "inline-block",
                  marginRight: "10px",
                }}
              ></span>

              <span
                className="fw-bold"
                style={{ color: brandColor }}
              >
                PUMP MOTOR SUPPLY
              </span>
            </div>

            {/* Main Heading */}
            <h2 className="fw-bold mb-3">
              Reliable Supply of High-Quality Pump Motors
            </h2>

            {/* Description */}
            <p className="text-muted">
              We specialize in the supply of high-quality pump motors designed
              to deliver reliable performance for residential, agricultural,
              commercial, and industrial applications.
            </p>

            <p className="text-muted">
              From product selection to timely delivery, we ensure that every
              pump motor supplied meets industry standards and customer
              requirements.
            </p>

            <hr />

            {/* CHECK LIST */}
            <ul className="list-unstyled mt-4">
              {[
                "Supply of high-quality pump motors for residential, agricultural, and industrial use.",
                "Wide range of pump motors including monoblock, submersible, and centrifugal motors.",
                "Expert assistance in selecting the right pump motor based on capacity and application.",
                "Energy-efficient pump motors designed to reduce power consumption.",
                "Durable construction ensuring long-lasting and reliable operation.",
                "Quality inspection and testing before delivery.",
                "Timely supply with reliable logistics support.",
                "Genuine products backed by manufacturer warranty.",
              ].map((item, index) => (
                <li key={index} className="d-flex align-items-start mb-3">
                  <span
                    className="me-3 d-flex align-items-center justify-content-center"
                    style={{
                      minWidth: "22px",
                      height: "22px",
                      backgroundColor: brandColor,
                      color: "#fff",
                      borderRadius: "4px",
                      fontSize: "11px",
                    }}
                  >
                    <FaArrowRight />
                  </span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>

          </div>

          {/* RIGHT IMAGE */}
          <div className="col-lg-6">
            <img
              src={imgMain}
              alt="pump motor supply"
className="img-fluid"            
              // style={{ width: "auto",  height:"500px"}}
            />
          </div>

        </div>
      </div>
    </section>
  );
};

export default Maintan;
